import React, { useEffect, useState, useContext } from "react";

import { AuthContext } from "../context/AuthContextProvider";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import GoogleMapWithSearch from "./GoogleMapWithSearch";
import * as Yup from "yup";
import { AddCentre, removeCenter, updateCentre } from "../api/settings";
import { toast } from "sonner";
import {
  ANALYTICS_EVENTS,
  CENTRE_TYPE,
  logAnalyticsEvent,
} from "../analytics";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { RequireAuth } from "../RequireAuth";
import { getDisplayRole } from "../utils/getDisplayText";
import CountryCodePicker from "./CountryCodePicker";
import SelectCenter from "./SelectCenter";
import { error } from "highcharts";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
  Stack,
  FormControlLabel,
  Checkbox,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { CloseIcon } from "stream-chat-react";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import Interpretation from "./../pages/Interpretation/Interpretation";
import ImageUploader from "./Reusables/ImageControls/ImageUploader";
import MultiImageUploader from "./Reusables/ImageControls/MultiImageUploader";
import { useGetIndianStates, useGetCitiesByState } from "../api/settings";
import ImageCropperDialog from "./ImageCropper";
import FormTextField from "./Reusables/FormControls/FormTextFeilds";
import FormSelect from "./Reusables/FormControls/FormSelect";
import CenterAddressPicker from "./Reusables/FormControls/FormAddressPicker";
import CenterTypeIcon from "./Reusables/FormControls/FormCentreIcons";
import HubFilter from "./Filters/AllHub";
import { formatText } from "./Reusables/TextValidation/SanitizeText";
import organisationType from "../data/organisationType.json";
import {
  getPhoneNumberLimit,
  sanitizePhoneNumber,
} from "../utils/phoneNumber";

const AddUpdateCenters = ({ type, item, handleManageCenters }) => {
  // Add these state/ref/hooks alongside your other logo state
  const facilityInputRef = React.useRef(null);
  // const [facilityFiles, setFacilityFiles] = useState([]); // array of File
  // const [facilityImages, setFacilityPreviews] = useState([]); // array of { id, url, name }
  const [facilityImages, setFacilityImages] = useState([]);

  const [removeUser, setRemoveUser] = useState(false);
  const { user } = useContext(AuthContext);
  const isMigratedUser = user?.userType === "b2b" && user?.migration === true;
  const centreRoleOptions = isMigratedUser
    ? ["Hub Centre"]
    : ["Hub Centre", "Spoke Centre"];
  const [address, setaddress] = useState(false);
  const [addNewMember, setaddNewMember] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const typeFromUrl = searchParams.get("type");
  const [selectedSpokeIds, setSelectedSpokeIds] = useState([]);
  const [abhaGuideOpen, setAbhaGuideOpen] = useState(false);
  const [countryCode, setCountryCode] = useState("+91"); // default or empt
  const phoneLimit = getPhoneNumberLimit(countryCode);
  const [addingCenter, setAddingCenter] = useState(true);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [initialCenter, setInitialCenter] = useState(null);
  const [isDirty, setIsDirty] = useState(false);

  const [cropOpen, setCropOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const navigate = useNavigate();

  const DropdownIcon = (props) => (
    <Icon
      icon="eva:arrow-ios-downward-fill"
      width="20"
      height="20"
      {...props} // ← IMPORTANT
    />
  );

  const [center, setCenter] = useState({
    centerId: "",
    centerName: "",
    centerType: "",
    centerPhoneNumber: "",
    type: "",
    centerAddress: "",
    enableSeparateBilling: false,
    businessName: "",
    businessTax: "",
    businessAddress: "",
    // Hub Centre or Spoke Centre. A migrated business only ever has hubs, so the
    // choice is already made for it rather than left blank for the user to pick.
    centerRole: isMigratedUser ? "Hub Centre" : "",
    billingPincode: "",
    billingState: "",
    billingCity: "",
    abha_facility_id: "",
    isSameAsAddress: false,
    canInterpretReport: false,
  });

  const [fulladdress, setfulladdress] = useState({
    floor: "",
    area: "",
    pincode: "",
    city: "",
    state: "",
    country: "",
    fulladdress: "",
    latitude: "",
    longitude: "",
    district: "",
  });
  const [errors, setErrors] = useState({});
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoFile, setLogoFile] = useState(null);

  const [members, setMembers] = useState([]);
  const addcenterSchema = Yup.object().shape({
    centerName: Yup.string()
      .min(2, "Too Short!")
      .max(150, "Too Long!")
      .required("Center Name is required"),
    type: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Center Type is required"),
    // centerPhoneNumber: Yup.string()
    //   .min(2, "Too Short!")
    //   .max(50, "Too Long!")
    //   .required("Center Phone Number is required"),

    centerAddress: Yup.string()
      .min(2, "Too Short!")
      .max(500, "Too Long!")
      .required("Center Address is required"),
    centerRole: Yup.string().required(
      "Please select whether this is a Hub Centre or Spoke Centre",
    ),
  });

  const billingDetailsSchema = Yup.object().shape({
    businessName: Yup.string().required("Business Name is required"),
    businessTax: Yup.string().required("Business Tax is required"),
    businessAddress: Yup.string().required("Business Address is required"),
    billingPincode: Yup.string().required("Pincode is required"),
    billingState: Yup.string().required("State is required"),
    billingCity: Yup.string().required("City is required"),
  });

  const selectSx = {
    height: "48px",
    borderRadius: "8px",
    backgroundColor: "var(--app-surface)",

    "& fieldset": {
      border: "1px solid var(--app-border) !important",
    },

    "&:hover fieldset": {
      border: "1px solid var(--app-border) !important",
    },

    "&.Mui-focused fieldset": {
      border: "1px solid var(--app-border) !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px", // change font size here
      fontWeight: 400, // optional
    },

    // Normal text
    "& .MuiSelect-select": {
      padding: "12px 14px",
      color: "var(--app-text)",
    },

    // DISABLED ROOT (background + border)
    "&.Mui-disabled": {
      backgroundColor: "var(--app-surface)",
      cursor: "not-allowed",
      opacity: 1, // remove fade
    },

    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--app-border)",
    },

    //  DISABLED TEXT
    "&.Mui-disabled .MuiSelect-select": {
      WebkitTextFillColor: "#A3A3A3", // disabled text color
      color: "#A3A3A3",
    },
  };
  const formLabelSx = {
    fontFamily: "Figtree",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0px",
    color: "var(--app-text-muted)",
    display: "block",
    mb: "6px",
  };
  const menuProps = {
    PaperProps: {
      sx: {
        maxHeight: 260,
        mt: 1,
        borderRadius: "12px",
      },
    },
  };
  useEffect(() => {
    if (item) {
      const mappedCenter = {
        centerId: item?.id,
        centerName: item?.name,
        centerType: item?.centerType,
        type: item?.type,
        centerPhoneNumber: item?.phone,
        centerAddress: item?.address?.fulladdress,
        // Migrated businesses have no spokes, and Spoke is not offered to them,
        // so editing one of their centres always lands on Hub - otherwise the
        // chip row would render with nothing selected.
        centerRole:
          isMigratedUser || item?.centerType === "hub"
            ? "Hub Centre"
            : "Spoke Centre",

        enableSeparateBilling: Boolean(
          item?.billingName ||
          item?.billingAddressTaxId ||
          item?.billingAddress ||
          item?.billingAddressState ||
          item?.billingAddressCity ||
          item?.billingAddressPin
        ),

        businessName: item?.billingName || "",
        businessTax: item?.billingAddressTaxId || "",
        businessAddress: item?.billingAddress || "",

        billingPincode: item?.billingAddressPin || "",
        billingState: item?.billingAddressState || "",
        billingCity: item?.billingAddressCity || "",

        abha_facility_id: item?.abha_facility_id,
        isSameAsAddress: item?.isSameAsAddress ?? false,
        canInterpretReport: item?.canInterpretReport ?? false,
      };
      setfulladdress({
        floor: item?.address?.floor,
        area: item?.address?.area,
        pincode: item?.address?.pincode,
        city: item?.address?.city,
        state: item?.address?.state,
        country: item?.address?.country,
        fulladdress: item?.address?.fulladdress,
        latitude: item?.address?.latitude,
        longitude: item?.address?.longitude,
        district: item?.address?.district,
      });

      if (!logoFile) {
        // only set preview from item if the user hasn't chosen a new file
        setLogoPreview(item?.logo);
      }

      // Find and set the parent hub for a spoke center
      if (item?.centerType === "spoke" && Array.isArray(item.hierarchy)) {
        const hub = item.hierarchy.find((h) => h.type === "hub");
        if (hub && hub.id) {
          setSelectedSpokeIds([hub.id]);
        }
      }

      if (item.members) {
        var newMember = [];
        item.members.forEach((member) => {
          newMember.push({
            firstName: member?.user?.firstName || "",
            middleName: member?.user?.middleName || "",
            lastName: member?.user?.lastName || "",
            email: member?.user?.email || "",
            phoneNumber: member?.user?.phoneNumber || "",
            role: member?.user?.role || "",
            displayRole: member?.user?.displayRole || "",
            designation: member?.user?.designation || "",
            centerIds: "[]",
            status: member?.user?.status || "",
          });
        });

        setMembers(newMember);
        setCenter(mappedCenter);
        setInitialCenter(mappedCenter);
        setCountryCode(item?.countryCode || item?.country_code || "+91");
        setIsDirty(false);
      }
    }
  }, [item, logoFile]);
  useEffect(() => {
    if (!initialCenter) return;

    const hasChanged =
      JSON.stringify(center) !== JSON.stringify(initialCenter) ||
      logoFile !== null ||
      facilityImages.some((img) => !img.existing) ||
      selectedSpokeIds.length > 0;

    setIsDirty(hasChanged);
  }, [center, logoFile, facilityImages, selectedSpokeIds, initialCenter]);

  useEffect(() => {
    // If URL has type=spoke and hub id, preselect values.
    // Skipped for a migrated business: the link that produces this URL is hidden
    // from them, so reaching it means a hand-typed address, and honouring it
    // would select a Spoke role that is no longer offered.
    if (!item && !isMigratedUser && typeFromUrl === "spoke" && id) {
      setCenter((prev) => ({
        ...prev,
        centerRole: "Spoke Centre", // auto select Spoke
      }));
      setSelectedSpokeIds([id]); // auto assign hub id in Belongs To
    }

    // If editing existing item, your current logic (already present) takes care of filling values
  }, [id, typeFromUrl, item, isMigratedUser]);

  //----------------- Here Center MUlti Images Handle ---------------------//

  const MAX_FACILITY_IMAGES = 4;

  // cleanup on unmount: revoke all created object URLs
  useEffect(() => {
    if (!item || facilityImages.length > 0) return;

    const existingImages =
      item.centerImages?.map((url, i) => ({
        id: `existing-${i}`,
        preview: url,
        existing: true,
        name: item.centerImagesName?.[i] || `image-${i}`,
      })) || [];

    setFacilityImages(existingImages);
  }, [item?.id]);

  //----------------- Here Center Logo Handle ---------------------//
  const logoInputRef = React.useRef(null);
  const handleLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";
    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result); // base64
      setCropOpen(true);
    };
    reader.readAsDataURL(file);

    // reset input so same file can be selected again
    if (logoInputRef.current) {
      logoInputRef.current.value = "";
    }
  };
  const handleCroppedLogo = (file) => {
    if (logoPreview) {
      try {
        URL.revokeObjectURL(logoPreview);
      } catch { }
    }

    const previewUrl = URL.createObjectURL(file);

    setLogoFile(file);
    setLogoPreview(previewUrl);
    setCropOpen(false);
  };

  const removeLogo = () => {
    setLogoFile(null);
    setLogoPreview(null);
    // reset the native file input so same file can be re-selected later
    if (logoInputRef.current) {
      logoInputRef.current.value = "";
    }
  };
  //   const formatText = (value) => {
  //   if (!value) return "";

  //   return value
  //     .trim()                  // remove start/end spaces
  //     .replace(/\s+/g, " ")    // replace multiple spaces with single
  //     .slice(0, 150);          // limit to 150 chars
  // };
  //----------------- End Here Center Logo Handle ---------------------//
  const handleAddCenter = async () => {
    try {
      //  sanitize all required fields
      const formatCenter = {
        ...center,
        centerName: formatText(center.centerName),
        businessName: formatText(center.businessName),
        centerAddress: formatText(center.centerAddress),
        businessAddress: formatText(center.businessAddress),
      };

      //  validate sanitized data
      const schema = formatCenter.enableSeparateBilling
        ? addcenterSchema.concat(billingDetailsSchema)
        : addcenterSchema;

      await schema.validate(formatCenter, { abortEarly: false });
      setErrors({});

      const dataIsSameAS = formatCenter.isSameAsAddress;

      const existingCenterImages = facilityImages
        .filter((img) => img.existing)
        .map((img) => img.name);

      const args2 = {
        phone_number: user.phoneNumber,
        phoneNumber: formatCenter.centerPhoneNumber,
        centerLogo: "",
        organisationPhone: formatCenter.centerPhoneNumber,
        countryCode: countryCode,
        organisationName: formatCenter.centerName,
        organisationType: formatCenter.centerType,
        centerRole: formatCenter.centerRole,
        address: fulladdress,
        centerImages: "",
        existingCenterImages,

        ...(formatCenter.enableSeparateBilling && {
          billingDetails: {
            name: formatCenter.businessName,
            taxId: formatCenter.businessTax,
            address: {
              line: formatCenter.businessAddress,
              state: formatCenter.billingState,
              city: formatCenter.billingCity,
              country: "",
              pincode: formatCenter.billingPincode,
            },
            isSameAsAddress: dataIsSameAS,
          },
        }),

        abha_facility_id: formatCenter.abha_facility_id,
        isSameAsAddress: dataIsSameAS,
        email: user.email,
        centerId: formatCenter.centerId,
        hub_centers: selectedSpokeIds,
        type: formatCenter.type,
        canInterpretReport: formatCenter.canInterpretReport,
      };

      setButtonLoading(true);

      const formData = new FormData();
      formData.append("centerDetails", JSON.stringify(args2));

      if (logoFile) {
        formData.append("centerLogo", logoFile);
      }

      // new images only
      facilityImages
        .filter((img) => !img.existing && img.file)
        .forEach((img) => {
          formData.append("centerImage", img.file);
        });

      formData.append("userDetails", JSON.stringify(members));

      let response;

      const isUpdate = formatCenter.centerId !== "";

      if (isUpdate) {
        response = await updateCentre(formData);
      } else {
        response = await AddCentre(formData);
      }

      if (response.success) {
        // Same form handles create and edit; an empty centerId is the create path.
        if (!isUpdate) {
          logAnalyticsEvent(ANALYTICS_EVENTS.CENTRE_ADDED, {
            new_centre_id:
              response?.data?.[0]?._id ||
              response?.data?._id ||
              response?.data?.centerId,
            // centerRole is the hub/spoke flag and is one of exactly two literals.
            // formatCenter.type is the organisation category ("Private
            // Organization"), which is a different field despite its name.
            centre_type:
              formatCenter.centerRole === "Hub Centre"
                ? CENTRE_TYPE.HUB
                : CENTRE_TYPE.SPOKE,
          });
        }
        toast.success(response.message);
        navigate("/settings/centres");
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      const formattedErrors = {};

      if (err.name === "ValidationError" && Array.isArray(err.inner)) {
        err.inner.forEach((e) => {
          if (e.path) formattedErrors[e.path] = e.message;
        });
        setErrors(formattedErrors);
      } else {
        toast.error(err.message || "Something went wrong");
        console.error("Unexpected Error:", err);
      }
    } finally {
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    if (!center.isSameAsAddress) return;

    setCenter((prev) => ({
      ...prev,
      businessName: prev.centerName,
      businessAddress: prev.centerAddress,
      billingPincode: fulladdress.pincode || "",
      billingState: fulladdress.state || "",
      billingCity: fulladdress.city || "",
    }));
  }, [
    center.centerName,
    center.centerAddress,
    fulladdress.pincode,
    fulladdress.state,
    fulladdress.city,
    center.isSameAsAddress,
  ]);

  const renderToggle = (props) => <i {...props} className="fa fa-ellipsis-v" />;

  const handleAddMember = (data) => {
    if (data !== null) {
      data.status = "inactive";
      const updatedMembers = [...(Array.isArray(members) ? members : []), data];
      setMembers(updatedMembers);
    }
    setaddNewMember(false);
  };

  const update_location = (location) => {
    const address = {
      floor: location.floor,
      area: location.area,
      pincode: location.pincode,
      city: location.city,
      state: location.state,
      country: location.country,
      fulladdress: location.fulladdress,
      latitude: location.latitude,
      longitude: location.longitude,
      district: location.district,
    };
    setaddress(false);
    const fullDisplayAddress = `${location.floor}, ${location.area}, ${location.district}, ${location.fulladdress}`;
    // Autofill billing State/City/Pincode from the geocoded address.
    // City is a free-solo Autocomplete, so any geocoded value is accepted even
    // when it isn't present in the (incomplete) CountriesNow city list.
    setCenter((prev) => ({
      ...prev,
      centerAddress: fullDisplayAddress,
      billingState: location.state || prev.billingState,
      billingCity: location.city || prev.billingCity,
      billingPincode: location.pincode || prev.billingPincode,
    }));
    setErrors((prev) => ({
      ...prev,
      billingState: location.state ? undefined : prev.billingState,
      billingCity: location.city ? undefined : prev.billingCity,
    }));
    setfulladdress(address);
  };

  const deleteCenter = async () => {
    try {
      const args = {
        centerId: center.centerId,
      };
      const response = await removeCenter(args);
      if (response.success) {
        toast.success(response.message);
      } else {
        toast.error(response.message || "Failed to delete center");
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
      console.error("Unexpected Error:", err);
    }
  };
  const isBillingSame = (checked) => {
    if (checked) {
      setCenter((prev) => ({
        ...prev,
        businessName: prev.centerName,
        businessAddress: prev.centerAddress,
        billingPincode: fulladdress.pincode || "",
        billingState: fulladdress.state || "",
        billingCity: fulladdress.city || "",
        isSameAsAddress: true,
      }));
    } else {
      setCenter((prev) => ({
        ...prev,
        isSameAsAddress: false,
      }));
    }
  };

  const handleSeparateBillingChange = (checked) => {
    setCenter((prev) => ({
      ...prev,
      enableSeparateBilling: checked,
      ...(checked
        ? {}
        : {
          businessName: "",
          businessTax: "",
          businessAddress: "",
          billingPincode: "",
          billingState: "",
          billingCity: "",
          isSameAsAddress: false,
        }),
    }));

    if (!checked) {
      setErrors((prev) => {
        const {
          businessName,
          businessTax,
          businessAddress,
          billingPincode,
          billingState,
          billingCity,
          ...rest
        } = prev;
        return rest;
      });
    }
  };

  const handleSpokeCenter = (selectedIds, centerType) => {
    const ids = Array.isArray(selectedIds) ? selectedIds : [selectedIds];

    setSelectedSpokeIds(ids);
  };

  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };

  const { states } = useGetIndianStates();
  const { cities } = useGetCitiesByState(
    center.billingState,
    !!center.billingState,
  );

  return (
    <>
      {/* Profile Card */}
      <Box className="card2 pt-20 mt-20" sx={{ p: 2.5, fontFamily: "Figtree" }}>
        <Typography
          variant="h5"
          component="h5"
          sx={{
            fontWeight: 700,
            fontSize: 20,
            color: "var(--app-text)",
            fontFamily: "Figtree",
          }}
        >
          Centre Details
        </Typography>

        {/* Input Fields */}

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            mt: 3,
          }}
        >
          {/* ================= ROW 1 ================= */}
          <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
            <FormTextField
              label="Centre Name"
              required
              value={center.centerName}
              onChange={(e) =>
                setCenter({ ...center, centerName: e.target.value })
              }
              errors={errors?.centerName}
              placeholder="Enter Centre Name"
            />
          </Box>

          <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 500,
                mb: "6px",
                color: "var(--app-text-muted)",
                fontFamily: "Figtree",
              }}
            >
              Contact Number
            </Typography>

            <Box display="flex" gap={1}>
              <Box sx={{ width: 90 }}>
                <CountryCodePicker
                  value={countryCode}
                  disabled={!!item}
                  onChange={(nextCountryCode) => {
                    setCountryCode(nextCountryCode);
                    setCenter((prev) => ({
                      ...prev,
                      centerPhoneNumber: sanitizePhoneNumber(
                        prev.centerPhoneNumber,
                        nextCountryCode
                      ),
                    }));
                  }}
                />
              </Box>

              <Box sx={{ flex: 1 }}>
                <FormTextField
                  placeholder="Enter Contact Number"
                  value={center.centerPhoneNumber}
                  limit={phoneLimit}
                  onChange={(e) =>
                    setCenter({
                      ...center,
                      centerPhoneNumber: sanitizePhoneNumber(
                        e.target.value,
                        countryCode
                      ),
                    })
                  }
                  errors={errors?.centerPhoneNumber}
                // disabled={type === "edit"}
                />
              </Box>
            </Box>
          </Box>

          <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
            <FormTextField
              label="ABHA Facility ID"
              value={center.abha_facility_id}
              onChange={(e) =>
                setCenter({ ...center, abha_facility_id: e.target.value })
              }
              errors={errors?.abha_facility_id}
              placeholder="Enter ABHA Facility ID"
              labelAction={
                <Typography
                  onClick={() => setAbhaGuideOpen(true)}
                  sx={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#5751E9",
                    cursor: "pointer",
                  }}
                >
                  How to set up ABHA?
                </Typography>
              }
            />
          </Box>

          {/* ================= ROW 2 ================= */}
          <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
            <FormSelect
              label="Centre Type"
              required
              placeholder="Select Centre Type"
              value={center.type}
              onChange={(e) =>
                setCenter((prev) => ({ ...prev, type: e.target.value }))
              }
              errors={errors?.type}
              options={organisationType.map((item) => ({
                label: item.label || item,
                value: item.value || item,
              }))}
            />
          </Box>

          <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
            <CenterAddressPicker
              label="Centre Address"
              required
              value={center.centerAddress}
              error={errors?.centerAddress}
              labelColor="var(--app-text-muted)"
              labelFontSize={14}
              labelFontWeight={500}
              onChange={(displayAddress, fullAddress) => {
                setCenter((prev) => ({
                  ...prev,
                  centerAddress: displayAddress,
                }));
                setfulladdress(fullAddress);
              }}
            />
          </Box>

          {/* ================= ROW 3 ================= */}
          <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 500,
                mb: "6px",
                color: "var(--app-text-muted)",
              }}
            >
              This Centre is a <span style={{ color: "#d32f2f" }}>*</span>
            </Typography>

            <Box display="flex" gap={1.5}>
              {centreRoleOptions.map((role) => {
                const selected = center.centerRole === role;

                // normalize to icon type
                const iconType = role.toLowerCase().includes("hub")
                  ? "hub"
                  : "spoke";

                return (
                  <Chip
                    key={role}
                    clickable
                    onClick={() => {
                      setCenter((prev) => ({ ...prev, centerRole: role }));

                      // Clear spoke selection when switching to Hub
                      if (role === "Hub Centre") {
                        setSelectedSpokeIds([]);
                      }
                    }}
                    label={
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{ fontWeight: 500 }}
                      >
                        <CenterTypeIcon
                          type={iconType}
                          size={18}
                          color={selected ? "#5751E9" : "var(--app-text-muted)"}
                        />
                        {role}
                      </Box>
                    }
                    sx={{
                      height: 48,
                      px: 2,
                      borderRadius: 2,
                      border: "1px solid",
                      borderColor: selected ? "#5751E9" : "var(--app-border)",
                      backgroundColor: selected ? "rgba(87, 81, 233, 0.15)" : "var(--app-surface-2)",
                      color: selected ? "#5751E9" : "var(--app-text)",
                      cursor: "pointer",

                      "& .MuiChip-label": {
                        px: 0, // remove default padding
                      },
                    }}
                  />
                );
              })}
            </Box>

            {errors.centerRole && (
              <Typography sx={{ color: "#d32f2f", fontSize: 12, mt: 0.5 }}>
                {errors.centerRole}
              </Typography>
            )}
          </Box>

          <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
            {center.centerRole === "Spoke Centre" && (
              <>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    mb: "6px",
                    color: "var(--app-text-muted)",
                  }}
                >
                  Belongs to <span style={{ color: "#d32f2f" }}>*</span>
                </Typography>

                {/* <SelectCenter
                  isMulti={false}
                  width="100%"
                  centerType="hub"
                  handleSelectChange={handleSpokeCenter}
                  selectedIds={selectedSpokeIds}
                  addingCenter={addingCenter}
                  errors={errors}
                /> */}
                <HubFilter
                  hubIds={selectedSpokeIds}
                  onChange={(ids) => setSelectedSpokeIds(ids)}
                />
              </>
            )}
          </Box>

          {/* ================= CHECKBOX ================= */}
          <Box sx={{ flex: "1 1 100%", mt: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={center.canInterpretReport}
                  onChange={(e) =>
                    setCenter((prev) => ({
                      ...prev,
                      canInterpretReport: e.target.checked,
                    }))
                  }
                  sx={{
                    color: "var(--app-border)",
                    "&.Mui-checked": { color: "warning.main" },
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                  }}
                />
              }
              label="This centre can receive reports for interpretation"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontFamily: "Figtree",
                  fontSize: 15,
                  fontWeight: 500,
                  color: "var(--app-text)",
                },
              }}
            />
          </Box>



          {/* ================= IMAGES ================= */}
          <Box sx={{ flex: "1 1 100%" }}>
            <Box display="flex" flexWrap="wrap" gap={1}>
              <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 18%" } }}>
                <ImageUploader
                  label="Centre Logo"
                  file={logoFile}
                  setFile={setLogoFile}
                  preview={logoPreview}
                  setPreview={setLogoPreview}
                />
              </Box>

              <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 80%" } }}>
                <MultiImageUploader
                  label="Centre Images (upto 4)"
                  images={facilityImages}
                  setImages={setFacilityImages}
                  centerAdd
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ flex: "1 1 100%" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={center.enableSeparateBilling}
              onChange={(e) =>
                handleSeparateBillingChange(e.target.checked)
              }
              sx={{
                color: "var(--app-border-2)",
                "&.Mui-checked": { color: "warning.main" },
                "& .MuiSvgIcon-root": { fontSize: 18 },
              }}
            />
          }
          label="Enable separate billing for this centre"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontFamily: "Figtree",
              fontSize: 15,
              fontWeight: 500,
              color: "var(--app-text)",
            },
          }}
        />
      </Box>

      {center.enableSeparateBilling && (
        <Box className="card2 pt-20 mt-20" sx={{ p: 2.5, fontFamily: "Figtree" }}>
          <Typography variant="h6" fontWeight={700} mb={2}>
            Billing Details
          </Typography>

          <FormControlLabel
            control={
              <Checkbox
                checked={center.isSameAsAddress}
                onChange={() => isBillingSame(!center.isSameAsAddress)}
                sx={{
                  color: "var(--app-border)",
                  "&.Mui-checked": {
                    color: "warning.main",
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: 18,
                  },
                }}
              />
            }
            label="Billing name and address same as above"
            sx={{
              mb: 3,
              "& .MuiFormControlLabel-label": {
                fontFamily: "Figtree",
                fontSize: 15,
                fontWeight: 500,
                color: "var(--app-text)",
              },
            }}
          />

          {/* ===== FORM GRID ===== */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
            }}
          >
            {/* Billing Name */}
            <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 48%" } }}>
              <FormTextField
                label="Name"
                required
                placeholder="Enter Billing Name"
                value={center.businessName}
                onChange={(e) =>
                  setCenter({ ...center, businessName: e.target.value })
                }
                errors={errors.businessName}
              />
            </Box>

            {/* Tax ID */}
            <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 48%" } }}>
              <FormTextField
                label="Tax ID"
                required
                placeholder="Enter Tax ID"
                value={center.businessTax}
                onChange={(e) =>
                  setCenter({ ...center, businessTax: e.target.value })
                }
                errors={errors.businessTax}
              />
            </Box>

            {/* Pincode */}
            <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
              <FormTextField
                label="Pincode"
                required
                placeholder="Enter Pincode"
                value={center.billingPincode}
                onChange={(e) =>
                  setCenter({ ...center, billingPincode: e.target.value })
                }
                errors={errors?.billingPincode}
              />
            </Box>

            {/* State */}
            <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
              <Typography
                component="label"
                sx={formLabelSx}
              >
                State <span style={{ color: "#d32f2f" }}>*</span>
              </Typography>

              <FormControl fullWidth size="small" error={!!errors?.billingState}>
                <Select
                  displayEmpty
                  value={center.billingState}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <Typography
                          component="span"
                          sx={{
                            color: "var(--app-text-muted)",
                            fontSize: "14px",
                            fontWeight: 400,
                            fontFamily: "Figtree",
                          }}
                        >
                          Select State
                        </Typography>
                      );
                    }

                    return (
                      <Typography
                        component="span"
                        sx={{
                          color: "var(--app-text)",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontFamily: "Figtree",
                        }}
                      >
                        {selected}
                      </Typography>
                    );
                  }}

                  onChange={(e) => {
                    setCenter({
                      ...center,
                      billingState: e.target.value,
                      billingCity: "",
                    });
                    setErrors((prev) => ({
                      ...prev,
                      billingState: undefined,
                      billingCity: undefined,
                    }));
                  }}
                  sx={selectSx}
                  MenuProps={menuProps}
                  IconComponent={DropdownIcon}
                >
                  <MenuItem value="" disabled>
                    Select State
                  </MenuItem>
                  {states.map((s) => (
                    <MenuItem key={s.name} value={s.name}>
                      {s.name}
                    </MenuItem>
                  ))}
                </Select>

                {errors?.billingState && (
                  <FormHelperText>{errors.billingState}</FormHelperText>
                )}
              </FormControl>
            </Box>

            {/* City */}
            <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
              <Typography
                component="label"
                sx={formLabelSx}
              >
                City <span style={{ color: "#d32f2f" }}>*</span>
              </Typography>

              <FormControl fullWidth size="small" error={!!errors?.billingCity}>
                <Autocomplete
                  freeSolo
                  autoSelect
                  disabled={!center.billingState}
                  options={cities}
                  value={center.billingCity || ""}
                  onChange={(_, newVal) => {
                    setCenter({ ...center, billingCity: newVal || "" });
                    setErrors((prev) => ({ ...prev, billingCity: undefined }));
                  }}
                  onInputChange={(_, newInput, reason) => {
                    if (reason === "input") {
                      setCenter({ ...center, billingCity: newInput });
                      setErrors((prev) => ({ ...prev, billingCity: undefined }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select or type city"
                      error={!!errors?.billingCity}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          ...selectSx,

                          // make border exactly same as Select
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid var(--app-border)",
                          },

                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid var(--app-border)",
                          },

                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid var(--app-border)",
                          },
                        },

                        "& .MuiAutocomplete-input": {
                          padding: "12px 14px !important",
                        },

                        "& .MuiAutocomplete-endAdornment": {
                          right: "8px",
                        },
                      }}
                    />
                  )}
                />
                {errors?.billingCity && (
                  <FormHelperText>{errors.billingCity}</FormHelperText>
                )}
              </FormControl>
            </Box>

            {/* Address */}
            <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 48%" } }}>
              <FormTextField
                label="Address"
                required
                placeholder="Enter full address"
                value={center.businessAddress}
                onChange={(e) =>
                  setCenter({ ...center, businessAddress: e.target.value })
                }
                errors={errors.businessAddress}
              />
            </Box>
          </Box>
        </Box>
      )}

      <Box sx={{ width: "100%", mt: 3, mb: 5 }}>
        <LoadingButton
          onClick={handleAddCenter}
          loading={buttonLoading}
          variant="contained"
          disabled={type === "edit" && !isDirty}
          sx={{
            textTransform: "none",
            borderRadius: "9px",
            opacity: type === "edit" && !isDirty ? 0.6 : 1,
            cursor: type === "edit" && !isDirty ? "not-allowed" : "pointer",
            fontFamily: "figtree",
            width: "169px",
            height: "48px",
            fontWeight: "600",
            color: type === "edit" && !isDirty ? "var(--app-text-muted)" : "#FFFFFF",
            boxShadow: "none",
            backgroundColor: "#5751E9",
            "&:hover": {
              backgroundColor: "#5751E9",
              boxShadow: "none",
            },
          }}
        >
          {type === "edit" ? "Update Centre" : "Save Centre"}
        </LoadingButton>
        &nbsp;
        {type == "edit" && (
          <>
            &nbsp; &nbsp;
            <Button
              onClick={() => setOpenRemoveDialog(true)}
              sx={{
                width: 169,
                height: 48,
                borderRadius: "9px",
                px: 2,
                py: 1.75,
                backgroundColor: "#FFDEDE",
                color: "#D34848",
                textTransform: "none",
                fontWeight: 600,
                boxShadow: "none",
                fontFamily: "figtree",
                "&:hover": {
                  backgroundColor: "#FFDEDG",
                  boxShadow: "none",
                },
              }}
            >
              Delete Centre
            </Button>
            <Dialog
              open={openRemoveDialog}
              onClose={() => setOpenRemoveDialog(false)}
              aria-labelledby="delete-center-dialog-title"
              PaperProps={{
                sx: {
                  borderRadius: "20px",
                  padding: "0px",
                  width: "508px",
                  boxShadow: "var(--app-shadow)",
                  position: "relative",
                  paddingLeft: "15px",
                },
              }}
            >
              {/* Close Icon */}
              <Icon
                icon="mdi:close"
                width="26"
                height="26"
                onClick={() => setOpenRemoveDialog(false)}
                style={{
                  position: "absolute",
                  right: 16,
                  top: 16,
                  cursor: "pointer",
                  color: "#444",
                }}
              />

              <DialogTitle
                id="delete-center-dialog-title"
                sx={{
                  textAlign: "center",
                  fontWeight: "700",
                  fontSize: "22px",
                  mb: 1,
                  mt: 2,
                }}
              >
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Icon
                    icon="mdi:alert"
                    width="65"
                    height="65"
                    style={{ color: "#E04A3A", marginBottom: "12px" }}
                  />
                  Delete Centre?
                </Box>
              </DialogTitle>

              <DialogContent sx={{ px: 4 }}>
                <Typography
                  align="center"
                  variant="body1"
                  sx={{
                    color: "var(--app-text-muted)",
                    fontSize: "16px",
                    lineHeight: "1.6",
                    mt: 1,
                  }}
                >
                  Are you sure you want to delete
                  <strong> {center.centerName}</strong>? Once deleted, this
                  centre cannot be retrieved and all centre data will be lost.
                </Typography>
              </DialogContent>

              <DialogActions
                className="spn-model-btn"
                sx={{
                  justifyContent: "center",
                  mt: 1,
                  gap: 2,
                  pb: 2,
                }}
              >
                {/* Left Button – Light Red */}
                <Button
                  className="btn btn-added-danger"
                  variant="contained"
                  size="medium"
                  sx={{
                    textTransform: "none",
                    borderRadius: "12px",
                    px: 4,
                    backgroundColor: "#FDE3E3",
                    color: "#C62828",
                    fontWeight: "600",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#F8D3D3",
                      boxShadow: "none",
                    },
                  }}
                  onClick={() => {
                    deleteCenter();
                    toast.success("Centre Deleted Successfully");
                    navigate("/settings/centres");
                    setOpenRemoveDialog(false);
                  }}
                >
                  Yes, Delete Centre
                </Button>

                {/* Right Button – Purple */}
                <Button
                  className="btn btn-added-primary"
                  variant="contained"
                  size="medium"
                  sx={{
                    textTransform: "none",
                    borderRadius: "12px",
                    px: 4,
                    backgroundColor: "#5A4FFA",
                    color: "white",
                    fontWeight: "600",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#4A3EEA",
                      boxShadow: "none",
                    },
                  }}
                  onClick={() => setOpenRemoveDialog(false)}
                >
                  No, Go Back
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Box>

      <Dialog
        open={address}
        onClose={() => setaddress(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{/* <h5>Select your Address</h5> */}</DialogTitle>

        <DialogContent>
          <GoogleMapWithSearch onAddressChange={update_location} />
        </DialogContent>
      </Dialog>
      {/* ABHA How-To Modal */}
      <Dialog
        open={abhaGuideOpen}
        onClose={() => setAbhaGuideOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 4, // rounded corners like your design
          },
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            px: 3,
            pt: 3,
            pb: 2,
            fontWeight: 700,
            fontSize: "24px",
          }}
        >
          How to Set Up ABHA
          {/* Close (X) button */}
          <IconButton
            aria-label="close"
            onClick={() => setAbhaGuideOpen(false)}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: (theme) => theme.palette.grey[600],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ px: 3, pt: 1.5, pb: 3 }}>
          <Typography sx={{ mb: 2 }}>
            To enable ABDM ABHA in Spandan One, you must have an ABDM-registered
            Health Facility and link it with Spandan One.
          </Typography>

          <Typography sx={{ mb: 2, fontWeight: 600 }}>
            Steps to link your ABDM-registered Health Facility to Spandan One :
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography fontWeight={600}>Step - 1</Typography>
            <Typography>
              Visit{" "}
              <a
                href="https://nhpr.abdm.gov.in/home"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#5751E9", textDecoration: "underline" }}
              >
                https://nhpr.abdm.gov.in/home
              </a>{" "}
              and log in or register.
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography fontWeight={600}>Step - 2</Typography>
            <Typography>
              Create a Health Facility if you do not already have one.
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography fontWeight={600}>Step - 3</Typography>
            <Typography>
              After creating the facility, open the <b>"Software Linkage"</b>{" "}
              option listed under that facility and enter Spandan One’s Software
              Bridge ID :
            </Typography>
            <Typography fontWeight={600} sx={{ mt: 0.5 }}>
              STPL_003
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography fontWeight={600}>Step - 4</Typography>
            <Typography>Create an HIP Name:</Typography>
            <ul style={{ marginTop: 6, paddingLeft: 18 }}>
              <li>
                The HIP name is formed by combining your hospital name
                (auto-filled) with a bridge name.
              </li>
              <li>
                Example: If your hospital name is XYZ and the bridge name is
                BRIDGE TEST, the HIP name will appear as <b>XYZ BRIDGE TEST</b>.
              </li>
              <li>
                For Spandan One, you can use <b>"SUNFOX"</b> as the bridge name.
              </li>
            </ul>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography fontWeight={600}>Step - 5</Typography>
            <Typography>
              Copy your Facility ID / HIP ID and paste it into the{" "}
              <b>ABHA Setup</b> field in Spandan One while creating or editing a
              centre.
            </Typography>
          </Box>

          <Box>
            <Typography fontWeight={600}>Step - 6</Typography>
            <Typography>
              Once saved, Spandan One will automatically verify the linkage. If
              successful, an <b>“ABHA”</b> label will appear.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0 }}>
          <button
            className="btn btn-added-primary w-100"
            onClick={() => {
              setAbhaGuideOpen(false);
              window.open("https://abdm.gov.in/", "_blank");
            }}
            style={{ borderRadius: 999 }}
          >
            Go to ABHA
          </button>
        </DialogActions>
      </Dialog>
      <ImageCropperDialog
        open={cropOpen}
        imageSrc={imageSrc}
        aspect={1} // 🔒 Centre logo is square
        onClose={() => setCropOpen(false)}
        onSave={handleCroppedLogo}
      />
    </>
  );
};

export default AddUpdateCenters;
